<template>
  <div class="modal-backdrop" v-show="show">
    <b-row no-gutters align-v="center" align-h="center" class="h-100 w-100">
      <b-img v-bind="$attrs" fluid alt="Imagem" class="min-max"></b-img>
      <b-button
        class="close-btn bg-white shadown-lg"
        pill
        size="lg"
        @click="$emit('close')"
        v-b-popover.hover.top="'Fechar pré-visualização'"
      >
        <font-awesome-icon icon="close" />
      </b-button>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "ImagePreview",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.close-btn {
  position: absolute;
  bottom: 0;
  margin-bottom: 4em;
  z-index: 100;
  width: 43px;
  height: 43px;
  line-height: 13px;
}
.shadown-lg {
  box-shadow: 1px 1px 1.5em rgba(0, 0, 0, 0.35);
}
.min-max {
  max-width: 1280px;
}
</style>
